import React from 'react'
import System from 'src/helper/system';
import { useOrderStore } from 'src/hooks/order';
import { useState, useEffect } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import ProductRepository from 'src/repository/ProductRepository';
import Product from "@system/config/product";
import useReduxState from 'src/hooks/useReduxState';
import Helper from 'src/support/Helper';
import { useThrottle } from "webrix/hooks";

const OrderDetailByDelivery = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ order_delivery_list, header_order_detail }, { fetch_order_list_by_delivery }, { order_download_single_invoice }] = useOrderStore();
    const [ascDesField, setAscDesField] = useState({});
    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [lineItemList, setLineItemList] = useState({});
    const [itemNumberList, setItemNumberList] = useState([]);
    const [expandRow, setExpandRow] = useState({});
    const [expandedRow, setExpandedRowT] = useState('')
    const setExpandedRow = useThrottle(setExpandedRowT, 1)

    useEffect(() => {
        async function fetchHere() {
            await getOrderListByDelivery()
        }

        fetchHere()
    }, []);

    useEffect(() => {
        async function fetchHere() {
            if (order_delivery_list && order_delivery_list.length > 0) {
                let orderList = [...order_delivery_list];
                let newList = {}
                let productList = []
                if (orderList && orderList.map((v, i) => {
                    if (v.items && v.items.length > 0) {
                        productList = productList.concat(v.items)
                        newList[v.shipNumber] = v.items
                    }
                })) {
                    let orderLineItems = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(productList, false, false);
                    setItemNumberList(orderLineItems)
                    setLineItemList(newList)
                }
            }
        }
        fetchHere()
    }, [order_delivery_list]);

    const getOrderListByDelivery = async () => {
        await fetch_order_list_by_delivery({
            orderNumber: System.getParams().order_number
        })
    }

    const sortAttributes = (columnName, shipNumber) => {
        let Attributes = { ...lineItemList }
        let AttributesSorted = {}
        if (ascDesField.hasOwnProperty(columnName)) {
            ascDesField[columnName] = ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setAscDesField(ascDesField)
        } else {
            ascDesField[columnName] = 'ASC'
            setAscDesField(ascDesField)
        }
        setSortBy(columnName)
        setSortOrder(ascDesField[columnName])

        if (Attributes && Object.entries(Attributes).length > 0) {
            Object.entries(Attributes).map((v, i) => {
                if (parseInt(v[0]) === shipNumber) {
                    let sortData = [...v[1]]
                    let sorted = []
                    if (ascDesField[columnName] === 'ASC') {
                        sorted = sortData.sort((a, b) => (b[columnName] < a[columnName] ? -1 : 1));
                    } else if (ascDesField[columnName] === 'DESC') {
                        sorted = sortData.sort((a, b) => (b[columnName] > a[columnName] ? -1 : 1));
                    }
                    AttributesSorted[v[0]] = sorted
                } else {
                    AttributesSorted[v[0]] = v[1]
                }
            })
        }

        setLineItemList(AttributesSorted)
    };

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const downloadSingleInvoice = async (invoiceNumber) => {
        await order_download_single_invoice({ invoiceNumber: invoiceNumber })
    }
    const getTrackingCarrierLink = (delivery) => {
        if (delivery !== undefined && delivery !== null &&
            delivery.items !== undefined &&
            delivery.items !== null &&
            Array.isArray(delivery.items) &&
            delivery.items.length > 0) {
            let carrier = Helper.getTrackingCarrier(delivery.items[0].carrier); // considering first item carrier
            if (carrier !== '') {
                const link = document.createElement('a');
                link.href = carrier + delivery.trackingNumber;
                link.target = '_blank';
                link.click();
            }
        }
        return false;
    }

    useEffect(() => {
        async function f() {
            if (expandedRow && expandedRow.shipNumber !== undefined) {
                let temp = { ...expandRow }
                temp[expandedRow.shipNumber] = expandedRow.status
                setExpandRow(temp)
            }

        }

        f()
    }, [expandedRow]);

    const handleClick = async (shipNumber, status, e) => {
        setExpandedRow({ shipNumber, status, UUID: Helper.UUID() })
    }

    const isLinkAvailable = (uniqueNumber) => {
        if (itemNumberList && itemNumberList.length > 0) {
            let itemNumber = ''
            itemNumberList.map((e) => {
                if (itemNumber !== '') {
                    return;
                }
                if (e.uniqueNumber === uniqueNumber && e.product && e.product.ItemNumber) {
                    itemNumber = e.product.ItemNumber
                }
            })
            if (itemNumber !== '') {
                return itemNumber
            }
        }
        return false
    }

    const getManufacturerName = (selectedItem) => {
        if(selectedItem.product!==undefined && 
            selectedItem.product!==null && 
            selectedItem.product.ManufacturerName!== undefined)
            {
                return selectedItem.product.ManufacturerName;
            }
            if(selectedItem.manufacturerName!==undefined &&
               selectedItem.manufacturerName!==null  &&
               selectedItem.manufacturerName.trim()!=='')
            {
                return selectedItem.manufacturerName
            }
            return '-';
    }
    return (
        <>
            {__check(['ORDER_API_CALL']).render}

            <div id="tab1" className="tab-pane fade position-relative in active">

                {order_delivery_list && order_delivery_list.length > 0 &&
                    !__check(['ORDER_API_CALL']).status &&
                    order_delivery_list.map((v, i) => (
                        <div className="accordion" id="orders">
                            <div className="accordion-item rounded-0">
                                <h2 className="accordion-header mb-0" id="headingOne">
                                    <button className="accordion-button accordion-white-button cursor-default">
                                        <div className="shipment-head">
                                            <div className="accordian-arrow">
                                                {order_delivery_list.length > 1 ?
                                                    <i
                                                        className={(expandRow[v.shipNumber] === undefined || expandRow[v.shipNumber] === false) ? 'fa fa-angle-double-down me-0 d-block' : 'fa fa-angle-double-up me-0 d-block'}

                                                        onClick={(e) => { handleClick(v.shipNumber, (expandRow[v.shipNumber] === undefined || expandRow[v.shipNumber] === false) ? true : false, e) }}
                                                    />
                                                    :
                                                    <i
                                                        className={(expandRow[v.shipNumber] === undefined || expandRow[v.shipNumber] === false) ? 'fa fa-angle-double-up me-0 d-block' : 'fa fa-angle-double-down me-0 d-block'}

                                                        onClick={(e) => { handleClick(v.shipNumber, (expandRow[v.shipNumber] === undefined || expandRow[v.shipNumber] === false) ? true : false, e) }}
                                                    />
                                                }
                                            </div>
                                            <div className="sub-section w240">
                                                <div><strong className="font-16 text-uppercase">{"Delivery Note " + (i + 1)}</strong></div>
                                                <div className='sub-section-data text-wrap'>{v.releaseNumber && v.releaseNumber.trim() !== '' ? v.releaseNumber : '-'}</div>
                                            </div>
                                            <div className="sub-section w240">
                                                <div><strong className="font-13">Tracking/Waybill Number</strong></div>
                                                {v.trackingNumber && v.trackingNumber.trim() !== '' ?
                                                    <div className='sub-section-data text-wrap'><a href={void (0)} onClick={() => getTrackingCarrierLink(v)} className="text-blue2">{v.trackingNumber}</a></div>
                                                    :
                                                    '-'
                                                }
                                            </div>
                                        </div>
                                    </button>
                                </h2>

                                {
                                    lineItemList[v.shipNumber] && lineItemList[v.shipNumber].length > 0 &&
                                    itemNumberList && itemNumberList.length > 0 &&
                                    <div
                                        className={(order_delivery_list.length > 1 ? (expandRow[v.shipNumber] === undefined || expandRow[v.shipNumber] === false ? 'accordion-collapse collapse' : 'accordion-collapse collapse in') :
                                            (expandRow[v.shipNumber] === undefined || expandRow[v.shipNumber] === false ? 'accordion-collapse collapse in' : 'accordion-collapse collapse'))}

                                        aria-labelledby="headingOne">
                                        <div className="accordion-body p-0">
                                            <div className="table-responsive">
                                                <table className="bs5 table table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th className="w40"></th>
                                                            <th className="">

                                                            </th>
                                                            <th className="w80"><span>Line Item <br />Number</span></th>
                                                            <th className={
                                                                getOrderByClass('manufacturer')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('manufacturer', v.shipNumber)
                                                                }}><span>Manufacturer</span></th>
                                                            <th className={
                                                                getOrderByClass('manufacturerPartNumber')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('manufacturerPartNumber', v.shipNumber)
                                                                }}><span>Manufacturer <br /> Part Number</span></th>
                                                            <th className={
                                                                getOrderByClass('customerPartNumber')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('customerPartNumber', v.shipNumber)
                                                                }}><span>Customer Part Number</span></th>
                                                            <th className={
                                                                getOrderByClass('orderedQuantity')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('orderedQuantity', v.shipNumber)
                                                                }}><span>Ordered Quantity</span></th>
                                                            <th className={
                                                                getOrderByClass('deliveredQuantity')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('deliveredQuantity', v.shipNumber)
                                                                }}><span>Shipped Quantity</span></th>
                                                            <th className={
                                                                getOrderByClass('remainingQuantity')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('remainingQuantity', v.shipNumber)
                                                                }}><span>Remaining Quantity</span></th>
                                                            <th className={
                                                                getOrderByClass('deliveryDate')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('deliveryDate', v.shipNumber)
                                                                }}>Delivery Date</th>
                                                            <th className={
                                                                getOrderByClass('totalPrice')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('totalPrice', v.shipNumber)
                                                                }}><span>Total Price</span></th>
                                                            <th className={
                                                                getOrderByClass('unitPrice')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('unitPrice', v.shipNumber)
                                                                }}><span>Unit Price</span></th>
                                                            <th><span>currency</span></th>
                                                            <th className={
                                                                getOrderByClass('orderDate')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('orderDate', v.shipNumber)
                                                                }}><span>Order Date</span></th>
                                                            <th className={
                                                                getOrderByClass('orderType')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('orderType', v.shipNumber)
                                                                }}><span>Order Type</span></th>
                                                            <th className={
                                                                getOrderByClass('orderStatus')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('orderStatus', v.shipNumber)
                                                                }}><span>Order Status</span></th>
                                                            <th className={
                                                                getOrderByClass('invoiceNumber')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('invoiceNumber', v.shipNumber)
                                                                }}><span>Invoice Number</span></th>
                                                            <th className={
                                                                getOrderByClass('carrier')
                                                            }
                                                                onClick={() => {
                                                                    sortAttributes('carrier', v.shipNumber)
                                                                }}><span>Carrier</span></th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {lineItemList[v.shipNumber].map((j, i) => (
                                                            <tr className="align-middle">
                                                                <td>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <a className="text-blue2 d-flex align-items-center" href={void (0)}
                                                                            onClick={() => System.popup('OrderHistoryEmailPopUp', {
                                                                                singleOrder: header_order_detail,
                                                                                singleProduct: j
                                                                            })}>
                                                                            <i className="fa fa-envelope font-16" aria-hidden="true"></i>
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>{j.lineItemNumber ? j.lineItemNumber : '-'}</div>
                                                                </td>

                                                                <td>{getManufacturerName(j)}</td>
                                                                <td>
                                                                    {
                                                                        isLinkAvailable(j.uniqueNumber) !== false ?
                                                                            <a href={Product.getProductDetailPageRouteURLWithCustomParameter(j) + '?ItemNumber=' + isLinkAvailable(j.uniqueNumber)}
                                                                                target="_blank"
                                                                                className="text-blue2 d-block font-bold" >{j.manufacturerPartNumber}</a>
                                                                            :
                                                                            <div>{j.manufacturerPartNumber}</div>
                                                                    }
                                                                </td>
                                                                <td><span className="text-nowrap">{j.customerPartNumber ? j.customerPartNumber : '-'}</span></td>
                                                                <td><span className="text-nowrap">{j.orderedQuantity && j.orderedQuantity}</span></td>
                                                                <td><span className="text-nowrap">{j.deliveredQuantity && j.deliveredQuantity}</span></td>
                                                                <td><span className="text-nowrap">{j.remainingQuantity && j.remainingQuantity}</span></td>
                                                                <td><span className="text-nowrap">{j.finalDeliveryDate ? j.finalDeliveryDate : '-'}</span></td>
                                                                <td><span className="text-nowrap">{j.totalPrice && j.currency !== undefined && j.currency !== null && j.currency.trim() != '' ? Helper.getFormatNumber(j.totalPrice, j.currency.trim()) : j.totalPrice}</span></td>
                                                                <td><span className="text-nowrap">{j.unitPrice && j.currency !== undefined && j.currency !== null && j.currency.trim() != '' ? Helper.getFormatNumber(j.unitPrice, j.currency.trim()) : j.unitPrice}</span></td>
                                                                <td><span className="text-nowrap">{j.currency ? j.currency : '-'}</span></td>
                                                                <td><span className="text-nowrap">{j.finalOrderDate ? j.finalOrderDate : '-'}</span></td>
                                                                <td><span className="text-nowrap">{j.orderType ? j.orderType : '-'}</span></td>
                                                                <td><span className="text-nowrap">{j.orderStatus ? j.orderStatus : '-'}</span></td>
                                                                <td><span className="text-nowrap">{j.invoiceNumber ? <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                                    onClick={() => downloadSingleInvoice(j.invoiceNumber)}>{j.invoiceNumber} </a> : '-'}</span></td>
                                                                <td><span className="text-nowrap">{j.carrier ? j.carrier : '-'}</span></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    ))
                }
            </div>

        </>

    )
}

export default OrderDetailByDelivery